import { createSlice } from "@reduxjs/toolkit";
import { showAttemptsSecurity, showUserSecurity } from "../actions";

const initialState = {
  userSecurity: [],
  attemptsSecurity: [],
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {},
  extraReducers: {
    [showAttemptsSecurity.fulfilled]: (state, action) => {
      state.attemptsSecurity = action.payload || [];
    },
    [showUserSecurity.fulfilled]: (state, action) => {
      state.userSecurity = action.payload || [];
    },
  },
});

export const responsePermission = (state) => state.permission;

export default permissionSlice.reducer;
